import React from 'react';
import '../dashboard/Dashboard.css';

function Greeting() {
   
    return (
        <div className="dashboard-greeting">
            <h1>Dashboard</h1>
            <p className="subtitle">
                An overview of your current debts & claims, requests, reminders and transaction history.
            </p>
        
            <p className="ready-text">
                Ready to split some bills and share great meals?
            </p>
{/*            <button className="btn primary-add-bill-btn">Add Bill</button>
*/}        </div>
    );
}

export default Greeting;